import {AudienceCategoryInfo, AudienceInterestInfo, AudienceSegmentInfo} from 'client/common/types';

import {ListItem, ListFilter} from 'client/common/store/reducers/surveys/types';

export enum ListView {
    Grid = 'GRID',
    Table = 'TABLE'
}

export interface ItemProps
    extends Pick<ListComponentProps, 'categories' | 'interests' | 'segments'> {
    survey: ListItem;
    isSuper: boolean;
}

export interface ListComponentProps extends Pick<ComponentProps, 'list' | 'isEntirelyLoaded'> {
    segments: AudienceSegmentInfo[];
    interests: AudienceInterestInfo[];
    categories: AudienceCategoryInfo[];
    loadMore: () => void;
}

export interface StateProps {
    list: ListItem[];
    filter: ListFilter;
    isDefaultFilter: boolean;
    isEntirelyLoaded: boolean;
    isLoadingSurveysList: boolean;
}

export type ComponentProps = StateProps;
